(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 4019:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 7942:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _slicedToArray = __webpack_require__(5696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(7273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(7294));

var _router = __webpack_require__(4957);

var _addLocale = __webpack_require__(7995);

var _routerContext = __webpack_require__(647);

var _appRouterContext = __webpack_require__(1992);

var _useIntersection = __webpack_require__(639);

var _getDomainLocale = __webpack_require__(4019);

var _addBasePath = __webpack_require__(227);

'client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push';
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react["default"].useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 1992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(7294));

var AppRouterContext = _react["default"].createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react["default"].createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react["default"].createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react["default"].createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 6994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/views/providers/AgreementProvider/index.tsx + 4 modules
var AgreementProvider = __webpack_require__(942);
// EXTERNAL MODULE: ./src/views/parts/bases/Center.tsx
var Center = __webpack_require__(4582);
// EXTERNAL MODULE: ./src/views/parts/bases/HStack.tsx
var HStack = __webpack_require__(1078);
// EXTERNAL MODULE: ./src/views/parts/bases/Text.tsx
var Text = __webpack_require__(1695);
// EXTERNAL MODULE: ./src/views/parts/bases/VStack.tsx
var VStack = __webpack_require__(2326);
// EXTERNAL MODULE: ./src/views/parts/buttons/PinkNeonButton.tsx
var PinkNeonButton = __webpack_require__(5167);
// EXTERNAL MODULE: ./src/views/parts/commons/GlobalNavigationHeader/Layout.tsx + 17 modules
var GlobalNavigationHeader_Layout = __webpack_require__(9275);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(2120);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/loginFrame.png
/* harmony default export */ var loginFrame = ({"src":"/_next/static/media/loginFrame.18fe689a.png","height":2019,"width":2265,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAGFBMVEUAAQIEFBUAGRkCExVfNlQBEBE2IjMAAAFM1XIJAAAAB3RSTlP9jerzrf2eY1E/8AAAAAlwSFlzAAAhOAAAITgBRZYxYAAAAClJREFUCJlVyUEKACAMxMBEW/b/PxaqF3MaCGqVSmdqFtNmhYQ85AN3HRg3ANMweG4/AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./public/images/metamaskLogo.png
var metamaskLogo = __webpack_require__(6912);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/services/PagePathService.ts
var PagePathService = __webpack_require__(19);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/views/pages/LoginPage/Layout.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var Layout = function Layout(props) {
  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
    className: "h-screen w-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GlobalNavigationHeader_Layout/* Layout */.A, _objectSpread({}, props.GlobalNavigationHeaderProps)), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
      className: "w-full flex-1 items-center pb-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "w-[700px] items-center p-[18px]",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Frame, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
            className: "mt-10 w-full max-w-[700px] flex-1 items-center justify-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
              className: "flex w-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
                className: "w-full items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
                  className: "mt-4 w-full items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                    className: "text-sm font-bold text-neon-blue",
                    children: t('LoginPage.EmailLabel')
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                    className: "ml-20 flex-1 rounded-lg border-2 border-neutral-800 bg-black p-2 font-bold text-white caret-neon-blue outline-0 focus:border-neon-blue",
                    onChange: function onChange(e) {
                      return props.onUpdateEmail(e.target.value);
                    }
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                  className: "my-9",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(PinkNeonButton/* PinkNeonButton */.u, {
                    onClick: props.onClickEmailLogin,
                    disabled: props.disabledSubmit,
                    children: t(props.visibleEmailLoginIndicator ? 'LoginPage.SubmitProcessing' : 'LoginPage.EmailLoginButton')
                  })
                })]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
            className: "relative items-center justify-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
              className: "h-px flex-1 bg-neon-blue bg-opacity-30"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
              className: "mx-4 text-neon-blue",
              children: "or"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
              className: "h-px flex-1 bg-neon-blue bg-opacity-30"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
            className: "my-4 flex-1 items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
              className: "relative mb-8 mt-4 aspect-[99/90] w-24",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: metamaskLogo/* default */.Z,
                layout: "fill",
                alt: ""
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PinkNeonButton/* PinkNeonButton */.u, {
              onClick: props.onClickMetamaskLogin,
              disabled: props.visibleMetamaskLoginIndicator,
              children: t(props.visibleMetamaskLoginIndicator ? 'LoginPage.SubmitProcessing' : 'LoginPage.MetamaskLoginButton')
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
              className: "mt-8",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: "text-white",
                children: t('LoginPage.SignUpLinkText')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: PagePathService/* PagePathService.signup */.v.signup(),
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "ml-2 text-akiverse-pink",
                  children: t('LoginPage.SignUpLinkLinkText')
                })
              })]
            })]
          })]
        })
      })
    })]
  });
};

var Frame = function Frame(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
    className: "h-full w-full",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
      className: "top-0 left-0 bottom-0 aspect-[2265/2019] w-full px-12 pt-14 pb-3",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: loginFrame,
        layout: "fill",
        alt: ""
      }), children]
    })
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/views/parts/commons/GlobalNavigationHeader/useProps.ts
var GlobalNavigationHeader_useProps = __webpack_require__(2317);
// EXTERNAL MODULE: ./src/services/ValidationService.ts
var ValidationService = __webpack_require__(8954);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(1383);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(1230);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(319);
;// CONCATENATED MODULE: ./src/views/pages/LoginPage/query.generated.ts
var _templateObject,_templateObject2;function query_generated_ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function query_generated_objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?query_generated_ownKeys(Object(source),!0).forEach(function(key){(0,defineProperty/* default */.Z)(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):query_generated_ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}var defaultOptions={};/** All built-in and custom scalars, mapped to their actual values */var ActiveBoosterForTournamentScalarFieldEnum;(function(ActiveBoosterForTournamentScalarFieldEnum){ActiveBoosterForTournamentScalarFieldEnum["Category"]="category";ActiveBoosterForTournamentScalarFieldEnum["CreatedAt"]="createdAt";ActiveBoosterForTournamentScalarFieldEnum["EndAt"]="endAt";ActiveBoosterForTournamentScalarFieldEnum["Id"]="id";ActiveBoosterForTournamentScalarFieldEnum["PaidTournamentId"]="paidTournamentId";ActiveBoosterForTournamentScalarFieldEnum["SubCategory"]="subCategory";ActiveBoosterForTournamentScalarFieldEnum["UpdatedAt"]="updatedAt";ActiveBoosterForTournamentScalarFieldEnum["UserId"]="userId";})(ActiveBoosterForTournamentScalarFieldEnum||(ActiveBoosterForTournamentScalarFieldEnum={}));var ActiveBoosterScalarFieldEnum;(function(ActiveBoosterScalarFieldEnum){ActiveBoosterScalarFieldEnum["Category"]="category";ActiveBoosterScalarFieldEnum["CreatedAt"]="createdAt";ActiveBoosterScalarFieldEnum["EndAt"]="endAt";ActiveBoosterScalarFieldEnum["Id"]="id";ActiveBoosterScalarFieldEnum["SubCategory"]="subCategory";ActiveBoosterScalarFieldEnum["UpdatedAt"]="updatedAt";ActiveBoosterScalarFieldEnum["UserId"]="userId";})(ActiveBoosterScalarFieldEnum||(ActiveBoosterScalarFieldEnum={}));var ArcadeMachineScalarFieldEnum;(function(ArcadeMachineScalarFieldEnum){ArcadeMachineScalarFieldEnum["AccumulatorSubCategory"]="accumulatorSubCategory";ArcadeMachineScalarFieldEnum["AutoRenewLease"]="autoRenewLease";ArcadeMachineScalarFieldEnum["Boost"]="boost";ArcadeMachineScalarFieldEnum["CreatedAt"]="createdAt";ArcadeMachineScalarFieldEnum["DestroyedAt"]="destroyedAt";ArcadeMachineScalarFieldEnum["Energy"]="energy";ArcadeMachineScalarFieldEnum["ExtractedEnergy"]="extractedEnergy";ArcadeMachineScalarFieldEnum["FeverSparkRemain"]="feverSparkRemain";ArcadeMachineScalarFieldEnum["Game"]="game";ArcadeMachineScalarFieldEnum["GameCenterId"]="gameCenterId";ArcadeMachineScalarFieldEnum["Id"]="id";ArcadeMachineScalarFieldEnum["InstalledAt"]="installedAt";ArcadeMachineScalarFieldEnum["LastBlock"]="lastBlock";ArcadeMachineScalarFieldEnum["LastTransactionIndex"]="lastTransactionIndex";ArcadeMachineScalarFieldEnum["LowerCabinetSubCategory"]="lowerCabinetSubCategory";ArcadeMachineScalarFieldEnum["MaxEnergy"]="maxEnergy";ArcadeMachineScalarFieldEnum["OwnerWalletAddress"]="ownerWalletAddress";ArcadeMachineScalarFieldEnum["PhysicalWalletAddress"]="physicalWalletAddress";ArcadeMachineScalarFieldEnum["Position"]="position";ArcadeMachineScalarFieldEnum["State"]="state";ArcadeMachineScalarFieldEnum["UpdatedAt"]="updatedAt";ArcadeMachineScalarFieldEnum["UpperCabinetSubCategory"]="upperCabinetSubCategory";ArcadeMachineScalarFieldEnum["UserId"]="userId";})(ArcadeMachineScalarFieldEnum||(ArcadeMachineScalarFieldEnum={}));var ArcadePartCategory;(function(ArcadePartCategory){ArcadePartCategory["Accumulator"]="ACCUMULATOR";ArcadePartCategory["LowerCabinet"]="LOWER_CABINET";ArcadePartCategory["Rom"]="ROM";ArcadePartCategory["UpperCabinet"]="UPPER_CABINET";})(ArcadePartCategory||(ArcadePartCategory={}));var ArcadePartScalarFieldEnum;(function(ArcadePartScalarFieldEnum){ArcadePartScalarFieldEnum["Category"]="category";ArcadePartScalarFieldEnum["CraftId"]="craftId";ArcadePartScalarFieldEnum["CreateDismantleId"]="createDismantleId";ArcadePartScalarFieldEnum["CreatedAt"]="createdAt";ArcadePartScalarFieldEnum["DestroyedAt"]="destroyedAt";ArcadePartScalarFieldEnum["Id"]="id";ArcadePartScalarFieldEnum["LastBlock"]="lastBlock";ArcadePartScalarFieldEnum["LastTransactionIndex"]="lastTransactionIndex";ArcadePartScalarFieldEnum["OwnerWalletAddress"]="ownerWalletAddress";ArcadePartScalarFieldEnum["PhysicalWalletAddress"]="physicalWalletAddress";ArcadePartScalarFieldEnum["State"]="state";ArcadePartScalarFieldEnum["SubCategory"]="subCategory";ArcadePartScalarFieldEnum["UpdatedAt"]="updatedAt";ArcadePartScalarFieldEnum["UsedJunks"]="usedJunks";ArcadePartScalarFieldEnum["UserId"]="userId";})(ArcadePartScalarFieldEnum||(ArcadePartScalarFieldEnum={}));var BannerImageType;(function(BannerImageType){BannerImageType["Banner"]="BANNER";BannerImageType["Interstitial"]="INTERSTITIAL";BannerImageType["PaidTournament"]="PAID_TOURNAMENT";})(BannerImageType||(BannerImageType={}));var BannerScalarFieldEnum;(function(BannerScalarFieldEnum){BannerScalarFieldEnum["BgImageUrl"]="bgImageUrl";BannerScalarFieldEnum["CreatedAt"]="createdAt";BannerScalarFieldEnum["Description"]="description";BannerScalarFieldEnum["Display"]="display";BannerScalarFieldEnum["EndAt"]="endAt";BannerScalarFieldEnum["ExternalLink"]="externalLink";BannerScalarFieldEnum["FrontEndType"]="frontEndType";BannerScalarFieldEnum["Id"]="id";BannerScalarFieldEnum["MainImageUrl"]="mainImageUrl";BannerScalarFieldEnum["StartAt"]="startAt";BannerScalarFieldEnum["TargetArea"]="targetArea";BannerScalarFieldEnum["UpdatedAt"]="updatedAt";})(BannerScalarFieldEnum||(BannerScalarFieldEnum={}));var BoosterCategory;(function(BoosterCategory){BoosterCategory["EasyMode"]="EASY_MODE";BoosterCategory["GameSwap"]="GAME_SWAP";BoosterCategory["SparkTerasUp"]="SPARK_TERAS_UP";})(BoosterCategory||(BoosterCategory={}));var BoosterMasterScalarFieldEnum;(function(BoosterMasterScalarFieldEnum){BoosterMasterScalarFieldEnum["Category"]="category";BoosterMasterScalarFieldEnum["CreatedAt"]="createdAt";BoosterMasterScalarFieldEnum["EffectiveMinutes"]="effectiveMinutes";BoosterMasterScalarFieldEnum["FeeTickets"]="feeTickets";BoosterMasterScalarFieldEnum["Id"]="id";BoosterMasterScalarFieldEnum["RequireTournament"]="requireTournament";BoosterMasterScalarFieldEnum["SubCategory"]="subCategory";BoosterMasterScalarFieldEnum["UpdatedAt"]="updatedAt";BoosterMasterScalarFieldEnum["Variant"]="variant";})(BoosterMasterScalarFieldEnum||(BoosterMasterScalarFieldEnum={}));var BurnScalarFieldEnum;(function(BurnScalarFieldEnum){BurnScalarFieldEnum["CreatedAt"]="createdAt";BurnScalarFieldEnum["ErrorMessage"]="errorMessage";BurnScalarFieldEnum["Hash"]="hash";BurnScalarFieldEnum["Id"]="id";BurnScalarFieldEnum["NftType"]="nftType";BurnScalarFieldEnum["Nonce"]="nonce";BurnScalarFieldEnum["Response"]="response";BurnScalarFieldEnum["SignerAddress"]="signerAddress";BurnScalarFieldEnum["State"]="state";BurnScalarFieldEnum["TokenId"]="tokenId";BurnScalarFieldEnum["UpdatedAt"]="updatedAt";BurnScalarFieldEnum["UserId"]="userId";})(BurnScalarFieldEnum||(BurnScalarFieldEnum={}));var BurnState;(function(BurnState){BurnState["Confirmed"]="CONFIRMED";BurnState["Error"]="ERROR";BurnState["Pending"]="PENDING";BurnState["Unprocessed"]="UNPROCESSED";})(BurnState||(BurnState={}));var CollectibleItemCategory;(function(CollectibleItemCategory){CollectibleItemCategory["Frame"]="FRAME";CollectibleItemCategory["Icon"]="ICON";CollectibleItemCategory["Title"]="TITLE";})(CollectibleItemCategory||(CollectibleItemCategory={}));var CollectibleItemScalarFieldEnum;(function(CollectibleItemScalarFieldEnum){CollectibleItemScalarFieldEnum["Category"]="category";CollectibleItemScalarFieldEnum["CreatedAt"]="createdAt";CollectibleItemScalarFieldEnum["Id"]="id";CollectibleItemScalarFieldEnum["SubCategory"]="subCategory";CollectibleItemScalarFieldEnum["UpdatedAt"]="updatedAt";CollectibleItemScalarFieldEnum["UserId"]="userId";})(CollectibleItemScalarFieldEnum||(CollectibleItemScalarFieldEnum={}));/** Currency used for crafting */var CraftCurrencyType;(function(CraftCurrencyType){CraftCurrencyType["Akv"]="AKV";CraftCurrencyType["Teras"]="TERAS";})(CraftCurrencyType||(CraftCurrencyType={}));var CraftScalarFieldEnum;(function(CraftScalarFieldEnum){CraftScalarFieldEnum["CraftedArcadeMachineId"]="craftedArcadeMachineId";CraftScalarFieldEnum["CreatedAt"]="createdAt";CraftScalarFieldEnum["Id"]="id";CraftScalarFieldEnum["UpdatedAt"]="updatedAt";CraftScalarFieldEnum["UsedAkvBalance"]="usedAkvBalance";CraftScalarFieldEnum["UsedTerasBalance"]="usedTerasBalance";CraftScalarFieldEnum["UserId"]="userId";})(CraftScalarFieldEnum||(CraftScalarFieldEnum={}));var CurrencyDepositScalarFieldEnum;(function(CurrencyDepositScalarFieldEnum){CurrencyDepositScalarFieldEnum["Amount"]="amount";CurrencyDepositScalarFieldEnum["CreatedAt"]="createdAt";CurrencyDepositScalarFieldEnum["CurrencyType"]="currencyType";CurrencyDepositScalarFieldEnum["Hash"]="hash";CurrencyDepositScalarFieldEnum["Id"]="id";CurrencyDepositScalarFieldEnum["State"]="state";CurrencyDepositScalarFieldEnum["UpdatedAt"]="updatedAt";CurrencyDepositScalarFieldEnum["UserId"]="userId";CurrencyDepositScalarFieldEnum["WalletAddress"]="walletAddress";})(CurrencyDepositScalarFieldEnum||(CurrencyDepositScalarFieldEnum={}));var CurrencyType;(function(CurrencyType){CurrencyType["Akir"]="AKIR";CurrencyType["Akv"]="AKV";CurrencyType["Usdc"]="USDC";})(CurrencyType||(CurrencyType={}));var DepositScalarFieldEnum;(function(DepositScalarFieldEnum){DepositScalarFieldEnum["CreatedAt"]="createdAt";DepositScalarFieldEnum["Hash"]="hash";DepositScalarFieldEnum["Id"]="id";DepositScalarFieldEnum["NftType"]="nftType";DepositScalarFieldEnum["State"]="state";DepositScalarFieldEnum["TokenId"]="tokenId";DepositScalarFieldEnum["UpdatedAt"]="updatedAt";DepositScalarFieldEnum["UserId"]="userId";DepositScalarFieldEnum["WalletAddress"]="walletAddress";})(DepositScalarFieldEnum||(DepositScalarFieldEnum={}));var DepositState;(function(DepositState){DepositState["Confirmed"]="CONFIRMED";DepositState["Invalidated"]="INVALIDATED";DepositState["Pending"]="PENDING";DepositState["Unprocessed"]="UNPROCESSED";})(DepositState||(DepositState={}));/** Currency used for dismantle */var DismantleCurrencyType;(function(DismantleCurrencyType){DismantleCurrencyType["Akv"]="AKV";DismantleCurrencyType["Teras"]="TERAS";})(DismantleCurrencyType||(DismantleCurrencyType={}));var DismantleScalarFieldEnum;(function(DismantleScalarFieldEnum){DismantleScalarFieldEnum["ArcadeMachineId"]="arcadeMachineId";DismantleScalarFieldEnum["CreatedAt"]="createdAt";DismantleScalarFieldEnum["FeverSparkRemain"]="feverSparkRemain";DismantleScalarFieldEnum["Id"]="id";DismantleScalarFieldEnum["UserId"]="userId";})(DismantleScalarFieldEnum||(DismantleScalarFieldEnum={}));/** Currency used for extracting */var ExtractCurrencyType;(function(ExtractCurrencyType){ExtractCurrencyType["Akv"]="AKV";ExtractCurrencyType["Teras"]="TERAS";})(ExtractCurrencyType||(ExtractCurrencyType={}));var ExtractInitialInventoryScalarFieldEnum;(function(ExtractInitialInventoryScalarFieldEnum){ExtractInitialInventoryScalarFieldEnum["Category"]="category";ExtractInitialInventoryScalarFieldEnum["CreatedAt"]="createdAt";ExtractInitialInventoryScalarFieldEnum["FeaturedItem"]="featuredItem";ExtractInitialInventoryScalarFieldEnum["Id"]="id";ExtractInitialInventoryScalarFieldEnum["InitialAmount"]="initialAmount";ExtractInitialInventoryScalarFieldEnum["ItemType"]="itemType";ExtractInitialInventoryScalarFieldEnum["SeasonId"]="seasonId";ExtractInitialInventoryScalarFieldEnum["SubCategory"]="subCategory";ExtractInitialInventoryScalarFieldEnum["UpdatedAt"]="updatedAt";})(ExtractInitialInventoryScalarFieldEnum||(ExtractInitialInventoryScalarFieldEnum={}));var ExtractJunkInventoryScalarFieldEnum;(function(ExtractJunkInventoryScalarFieldEnum){ExtractJunkInventoryScalarFieldEnum["Amount"]="amount";ExtractJunkInventoryScalarFieldEnum["Category"]="category";ExtractJunkInventoryScalarFieldEnum["CreatedAt"]="createdAt";ExtractJunkInventoryScalarFieldEnum["SubCategory"]="subCategory";ExtractJunkInventoryScalarFieldEnum["UpdatedAt"]="updatedAt";})(ExtractJunkInventoryScalarFieldEnum||(ExtractJunkInventoryScalarFieldEnum={}));var ExtractScalarFieldEnum;(function(ExtractScalarFieldEnum){ExtractScalarFieldEnum["ArcadeMachineId"]="arcadeMachineId";ExtractScalarFieldEnum["CreatedAt"]="createdAt";ExtractScalarFieldEnum["ExtractArcadePartsCount"]="extractArcadePartsCount";ExtractScalarFieldEnum["ExtractDetail"]="extractDetail";ExtractScalarFieldEnum["ExtractJunkPartsCount"]="extractJunkPartsCount";ExtractScalarFieldEnum["Id"]="id";ExtractScalarFieldEnum["UpdatedAt"]="updatedAt";ExtractScalarFieldEnum["UserId"]="userId";})(ExtractScalarFieldEnum||(ExtractScalarFieldEnum={}));var ExtractableItemType;(function(ExtractableItemType){ExtractableItemType["ArcadePart"]="ARCADE_PART";ExtractableItemType["JunkPart"]="JUNK_PART";})(ExtractableItemType||(ExtractableItemType={}));var FrontEndType;(function(FrontEndType){FrontEndType["Gp"]="GP";FrontEndType["Wm"]="WM";})(FrontEndType||(FrontEndType={}));var GameCenterArea;(function(GameCenterArea){GameCenterArea["Akihabara"]="AKIHABARA";GameCenterArea["Shibuya"]="SHIBUYA";})(GameCenterArea||(GameCenterArea={}));var GameCenterScalarFieldEnum;(function(GameCenterScalarFieldEnum){GameCenterScalarFieldEnum["Area"]="area";GameCenterScalarFieldEnum["CreatedAt"]="createdAt";GameCenterScalarFieldEnum["Id"]="id";GameCenterScalarFieldEnum["LastBlock"]="lastBlock";GameCenterScalarFieldEnum["LastTransactionIndex"]="lastTransactionIndex";GameCenterScalarFieldEnum["Name"]="name";GameCenterScalarFieldEnum["OwnerWalletAddress"]="ownerWalletAddress";GameCenterScalarFieldEnum["PhysicalWalletAddress"]="physicalWalletAddress";GameCenterScalarFieldEnum["PlacementAllowed"]="placementAllowed";GameCenterScalarFieldEnum["Size"]="size";GameCenterScalarFieldEnum["State"]="state";GameCenterScalarFieldEnum["UpdatedAt"]="updatedAt";GameCenterScalarFieldEnum["UserId"]="userId";GameCenterScalarFieldEnum["XCoordinate"]="xCoordinate";GameCenterScalarFieldEnum["YCoordinate"]="yCoordinate";})(GameCenterScalarFieldEnum||(GameCenterScalarFieldEnum={}));var GameCenterSize;(function(GameCenterSize){GameCenterSize["Large"]="LARGE";GameCenterSize["Medium"]="MEDIUM";GameCenterSize["Small"]="SMALL";})(GameCenterSize||(GameCenterSize={}));var IconType;(function(IconType){IconType["InWorld"]="IN_WORLD";IconType["Nft"]="NFT";})(IconType||(IconType={}));var InterstitialBannerScalarFieldEnum;(function(InterstitialBannerScalarFieldEnum){InterstitialBannerScalarFieldEnum["CreatedAt"]="createdAt";InterstitialBannerScalarFieldEnum["Description"]="description";InterstitialBannerScalarFieldEnum["Display"]="display";InterstitialBannerScalarFieldEnum["EndAt"]="endAt";InterstitialBannerScalarFieldEnum["ExternalLink"]="externalLink";InterstitialBannerScalarFieldEnum["Id"]="id";InterstitialBannerScalarFieldEnum["ImageUrl"]="imageUrl";InterstitialBannerScalarFieldEnum["RemainingTimeVisible"]="remainingTimeVisible";InterstitialBannerScalarFieldEnum["StartAt"]="startAt";InterstitialBannerScalarFieldEnum["TargetArea"]="targetArea";InterstitialBannerScalarFieldEnum["UpdatedAt"]="updatedAt";})(InterstitialBannerScalarFieldEnum||(InterstitialBannerScalarFieldEnum={}));var JunkScalarFieldEnum;(function(JunkScalarFieldEnum){JunkScalarFieldEnum["Amount"]="amount";JunkScalarFieldEnum["Category"]="category";JunkScalarFieldEnum["CreatedAt"]="createdAt";JunkScalarFieldEnum["Id"]="id";JunkScalarFieldEnum["SubCategory"]="subCategory";JunkScalarFieldEnum["UpdatedAt"]="updatedAt";JunkScalarFieldEnum["UserId"]="userId";})(JunkScalarFieldEnum||(JunkScalarFieldEnum={}));var NewsCategory;(function(NewsCategory){NewsCategory["Event"]="EVENT";NewsCategory["Info"]="INFO";NewsCategory["Promo"]="PROMO";})(NewsCategory||(NewsCategory={}));var NewsScalarFieldEnum;(function(NewsScalarFieldEnum){NewsScalarFieldEnum["Category"]="category";NewsScalarFieldEnum["CreatedAt"]="createdAt";NewsScalarFieldEnum["Display"]="display";NewsScalarFieldEnum["EndAt"]="endAt";NewsScalarFieldEnum["ExternalLink"]="externalLink";NewsScalarFieldEnum["Id"]="id";NewsScalarFieldEnum["StartAt"]="startAt";NewsScalarFieldEnum["Title"]="title";NewsScalarFieldEnum["UpdatedAt"]="updatedAt";})(NewsScalarFieldEnum||(NewsScalarFieldEnum={}));var NftState;(function(NftState){NftState["Burned"]="BURNED";NftState["Burning"]="BURNING";NftState["InAkiverse"]="IN_AKIVERSE";NftState["InWallet"]="IN_WALLET";NftState["MovingToAkiverse"]="MOVING_TO_AKIVERSE";NftState["MovingToWallet"]="MOVING_TO_WALLET";})(NftState||(NftState={}));var NftType;(function(NftType){NftType["ArcadeMachine"]="ARCADE_MACHINE";NftType["ArcadePart"]="ARCADE_PART";NftType["GameCenter"]="GAME_CENTER";})(NftType||(NftType={}));var NotificationScalarFieldEnum;(function(NotificationScalarFieldEnum){NotificationScalarFieldEnum["CreatedAt"]="createdAt";NotificationScalarFieldEnum["Id"]="id";NotificationScalarFieldEnum["MessageDetailJson"]="messageDetailJson";NotificationScalarFieldEnum["MessageJson"]="messageJson";NotificationScalarFieldEnum["NftType"]="nftType";NotificationScalarFieldEnum["NotificationType"]="notificationType";NotificationScalarFieldEnum["TokenId"]="tokenId";NotificationScalarFieldEnum["UpdatedAt"]="updatedAt";NotificationScalarFieldEnum["UserId"]="userId";})(NotificationScalarFieldEnum||(NotificationScalarFieldEnum={}));var NotificationType;(function(NotificationType){NotificationType["Activity"]="ACTIVITY";NotificationType["Information"]="INFORMATION";})(NotificationType||(NotificationType={}));var NullsOrder;(function(NullsOrder){NullsOrder["First"]="first";NullsOrder["Last"]="last";})(NullsOrder||(NullsOrder={}));var OperatingSystem;(function(OperatingSystem){OperatingSystem["Android"]="ANDROID";OperatingSystem["Ios"]="IOS";})(OperatingSystem||(OperatingSystem={}));var PaidTournamentBoosterAvailableScalarFieldEnum;(function(PaidTournamentBoosterAvailableScalarFieldEnum){PaidTournamentBoosterAvailableScalarFieldEnum["BoosterMasterId"]="boosterMasterId";PaidTournamentBoosterAvailableScalarFieldEnum["CreatedAt"]="createdAt";PaidTournamentBoosterAvailableScalarFieldEnum["Id"]="id";PaidTournamentBoosterAvailableScalarFieldEnum["PaidTournamentId"]="paidTournamentId";PaidTournamentBoosterAvailableScalarFieldEnum["UpdatedAt"]="updatedAt";})(PaidTournamentBoosterAvailableScalarFieldEnum||(PaidTournamentBoosterAvailableScalarFieldEnum={}));var PaidTournamentEntryScalarFieldEnum;(function(PaidTournamentEntryScalarFieldEnum){PaidTournamentEntryScalarFieldEnum["CountryFromIp"]="countryFromIp";PaidTournamentEntryScalarFieldEnum["CreatedAt"]="createdAt";PaidTournamentEntryScalarFieldEnum["Id"]="id";PaidTournamentEntryScalarFieldEnum["PaidTournamentId"]="paidTournamentId";PaidTournamentEntryScalarFieldEnum["PhoneNumber"]="phoneNumber";PaidTournamentEntryScalarFieldEnum["PrizeClaimed"]="prizeClaimed";PaidTournamentEntryScalarFieldEnum["PrizeSendStatus"]="prizeSendStatus";PaidTournamentEntryScalarFieldEnum["UpdatedAt"]="updatedAt";PaidTournamentEntryScalarFieldEnum["UsedTickets"]="usedTickets";PaidTournamentEntryScalarFieldEnum["UserId"]="userId";PaidTournamentEntryScalarFieldEnum["WalletAddress"]="walletAddress";})(PaidTournamentEntryScalarFieldEnum||(PaidTournamentEntryScalarFieldEnum={}));var PaidTournamentScalarFieldEnum;(function(PaidTournamentScalarFieldEnum){PaidTournamentScalarFieldEnum["CreatedAt"]="createdAt";PaidTournamentScalarFieldEnum["EndAt"]="endAt";PaidTournamentScalarFieldEnum["EntryFeeTickets"]="entryFeeTickets";PaidTournamentScalarFieldEnum["GameId"]="gameId";PaidTournamentScalarFieldEnum["Id"]="id";PaidTournamentScalarFieldEnum["ImageUrl"]="imageUrl";PaidTournamentScalarFieldEnum["PaidTournamentType"]="paidTournamentType";PaidTournamentScalarFieldEnum["PrizeSent"]="prizeSent";PaidTournamentScalarFieldEnum["PrizeTerasAmount"]="prizeTerasAmount";PaidTournamentScalarFieldEnum["PrizeTerasOnly"]="prizeTerasOnly";PaidTournamentScalarFieldEnum["ResultRecorded"]="resultRecorded";PaidTournamentScalarFieldEnum["StartAt"]="startAt";PaidTournamentScalarFieldEnum["TargetArea"]="targetArea";PaidTournamentScalarFieldEnum["Title"]="title";PaidTournamentScalarFieldEnum["UpdatedAt"]="updatedAt";})(PaidTournamentScalarFieldEnum||(PaidTournamentScalarFieldEnum={}));var PaidTournamentType;(function(PaidTournamentType){PaidTournamentType["SparkCount"]="SPARK_COUNT";PaidTournamentType["SparkTeras"]="SPARK_TERAS";})(PaidTournamentType||(PaidTournamentType={}));var PlayResult;(function(PlayResult){PlayResult["Disconnected"]="DISCONNECTED";PlayResult["Loss"]="LOSS";PlayResult["Win"]="WIN";})(PlayResult||(PlayResult={}));var PlayScalarFieldEnum;(function(PlayScalarFieldEnum){PlayScalarFieldEnum["CreatedAt"]="createdAt";PlayScalarFieldEnum["EndedAt"]="endedAt";PlayScalarFieldEnum["Id"]="id";PlayScalarFieldEnum["MegaSpark"]="megaSpark";PlayScalarFieldEnum["OwnerTerasReward"]="ownerTerasReward";PlayScalarFieldEnum["PlaySessionId"]="playSessionId";PlayScalarFieldEnum["PlayerTerasReward"]="playerTerasReward";PlayScalarFieldEnum["Result"]="result";PlayScalarFieldEnum["Score"]="score";PlayScalarFieldEnum["TerasBoosterRatio"]="terasBoosterRatio";PlayScalarFieldEnum["UpdatedAt"]="updatedAt";})(PlayScalarFieldEnum||(PlayScalarFieldEnum={}));var PlaySessionScalarFieldEnum;(function(PlaySessionScalarFieldEnum){PlaySessionScalarFieldEnum["ArcadeMachineId"]="arcadeMachineId";PlaySessionScalarFieldEnum["ArcadeMachineOwnerId"]="arcadeMachineOwnerId";PlaySessionScalarFieldEnum["AuthToken"]="authToken";PlaySessionScalarFieldEnum["CreatedAt"]="createdAt";PlaySessionScalarFieldEnum["Difficulty"]="difficulty";PlaySessionScalarFieldEnum["EndedAt"]="endedAt";PlaySessionScalarFieldEnum["Fever"]="fever";PlaySessionScalarFieldEnum["GameCenterId"]="gameCenterId";PlaySessionScalarFieldEnum["GameCenterOwnerId"]="gameCenterOwnerId";PlaySessionScalarFieldEnum["Id"]="id";PlaySessionScalarFieldEnum["MaxPlayCount"]="maxPlayCount";PlaySessionScalarFieldEnum["PlayerId"]="playerId";PlaySessionScalarFieldEnum["State"]="state";PlaySessionScalarFieldEnum["TargetScore"]="targetScore";PlaySessionScalarFieldEnum["UpdatedAt"]="updatedAt";})(PlaySessionScalarFieldEnum||(PlaySessionScalarFieldEnum={}));var PlaySessionState;(function(PlaySessionState){PlaySessionState["Finished"]="FINISHED";PlaySessionState["Playing"]="PLAYING";PlaySessionState["Ready"]="READY";})(PlaySessionState||(PlaySessionState={}));/** Prize claim type */var PrizeClaimType;(function(PrizeClaimType){PrizeClaimType["PhoneNumber"]="PHONE_NUMBER";PrizeClaimType["WalletAddress"]="WALLET_ADDRESS";})(PrizeClaimType||(PrizeClaimType={}));var PrizeSendStatus;(function(PrizeSendStatus){PrizeSendStatus["Confirmed"]="CONFIRMED";PrizeSendStatus["Error"]="ERROR";PrizeSendStatus["Pending"]="PENDING";PrizeSendStatus["Unprocessed"]="UNPROCESSED";})(PrizeSendStatus||(PrizeSendStatus={}));var PurchaseStatus;(function(PurchaseStatus){PurchaseStatus["Canceled"]="CANCELED";PurchaseStatus["Granted"]="GRANTED";PurchaseStatus["Invalid"]="INVALID";PurchaseStatus["Unprocessed"]="UNPROCESSED";})(PurchaseStatus||(PurchaseStatus={}));var QueryMode;(function(QueryMode){QueryMode["Default"]="default";QueryMode["Insensitive"]="insensitive";})(QueryMode||(QueryMode={}));var QuestChainCategory;(function(QuestChainCategory){QuestChainCategory["Event"]="EVENT";QuestChainCategory["Onward"]="ONWARD";QuestChainCategory["Vip"]="VIP";})(QuestChainCategory||(QuestChainCategory={}));var QuestChainMasterScalarFieldEnum;(function(QuestChainMasterScalarFieldEnum){QuestChainMasterScalarFieldEnum["AkvRequiredForRelease"]="akvRequiredForRelease";QuestChainMasterScalarFieldEnum["BeforeQuestChainId"]="beforeQuestChainId";QuestChainMasterScalarFieldEnum["ChainCategory"]="chainCategory";QuestChainMasterScalarFieldEnum["EndAt"]="endAt";QuestChainMasterScalarFieldEnum["Id"]="id";QuestChainMasterScalarFieldEnum["SpecifiedTitleImage"]="specifiedTitleImage";QuestChainMasterScalarFieldEnum["StartAt"]="startAt";QuestChainMasterScalarFieldEnum["TerasRequiredForRelease"]="terasRequiredForRelease";QuestChainMasterScalarFieldEnum["TicketRequiredForRelease"]="ticketRequiredForRelease";QuestChainMasterScalarFieldEnum["Title"]="title";})(QuestChainMasterScalarFieldEnum||(QuestChainMasterScalarFieldEnum={}));var QuestChainRewardMasterScalarFieldEnum;(function(QuestChainRewardMasterScalarFieldEnum){QuestChainRewardMasterScalarFieldEnum["Amount"]="amount";QuestChainRewardMasterScalarFieldEnum["Category"]="category";QuestChainRewardMasterScalarFieldEnum["Id"]="id";QuestChainRewardMasterScalarFieldEnum["ItemType"]="itemType";QuestChainRewardMasterScalarFieldEnum["QuestChainMasterId"]="questChainMasterId";QuestChainRewardMasterScalarFieldEnum["SubCategory"]="subCategory";})(QuestChainRewardMasterScalarFieldEnum||(QuestChainRewardMasterScalarFieldEnum={}));var QuestChainScalarFieldEnum;(function(QuestChainScalarFieldEnum){QuestChainScalarFieldEnum["AcceptedAt"]="acceptedAt";QuestChainScalarFieldEnum["Completed"]="completed";QuestChainScalarFieldEnum["CreatedAt"]="createdAt";QuestChainScalarFieldEnum["ExpiredAt"]="expiredAt";QuestChainScalarFieldEnum["Id"]="id";QuestChainScalarFieldEnum["QuestChainMasterId"]="questChainMasterId";QuestChainScalarFieldEnum["UpdatedAt"]="updatedAt";QuestChainScalarFieldEnum["UserId"]="userId";})(QuestChainScalarFieldEnum||(QuestChainScalarFieldEnum={}));var QuestMasterScalarFieldEnum;(function(QuestMasterScalarFieldEnum){QuestMasterScalarFieldEnum["Amount"]="amount";QuestMasterScalarFieldEnum["BeforeQuestIds"]="beforeQuestIds";QuestMasterScalarFieldEnum["Category"]="category";QuestMasterScalarFieldEnum["Id"]="id";QuestMasterScalarFieldEnum["ItemType"]="itemType";QuestMasterScalarFieldEnum["ProgressGoal"]="progressGoal";QuestMasterScalarFieldEnum["ProgressParams"]="progressParams";QuestMasterScalarFieldEnum["ProgressType"]="progressType";QuestMasterScalarFieldEnum["QuestChainMasterId"]="questChainMasterId";QuestMasterScalarFieldEnum["Seq"]="seq";QuestMasterScalarFieldEnum["SubCategory"]="subCategory";QuestMasterScalarFieldEnum["Title"]="title";})(QuestMasterScalarFieldEnum||(QuestMasterScalarFieldEnum={}));var QuestProgressType;(function(QuestProgressType){QuestProgressType["ConnectWallet"]="CONNECT_WALLET";QuestProgressType["ConsecutivePlayDaysInDifferentGame"]="CONSECUTIVE_PLAY_DAYS_IN_DIFFERENT_GAME";QuestProgressType["ConsecutiveSparkCount"]="CONSECUTIVE_SPARK_COUNT";QuestProgressType["ConsecutiveSparkDays"]="CONSECUTIVE_SPARK_DAYS";QuestProgressType["PlayCount"]="PLAY_COUNT";QuestProgressType["SparkCount"]="SPARK_COUNT";QuestProgressType["UniqueGamePlayCount"]="UNIQUE_GAME_PLAY_COUNT";QuestProgressType["UniqueGameSparkCount"]="UNIQUE_GAME_SPARK_COUNT";QuestProgressType["UniquePlayDays"]="UNIQUE_PLAY_DAYS";})(QuestProgressType||(QuestProgressType={}));var QuestRewardCategory;(function(QuestRewardCategory){QuestRewardCategory["Accumulator"]="ACCUMULATOR";QuestRewardCategory["Frame"]="FRAME";QuestRewardCategory["Icon"]="ICON";QuestRewardCategory["LowerCabinet"]="LOWER_CABINET";QuestRewardCategory["Random"]="RANDOM";QuestRewardCategory["Rom"]="ROM";QuestRewardCategory["Teras"]="TERAS";QuestRewardCategory["Title"]="TITLE";QuestRewardCategory["UpperCabinet"]="UPPER_CABINET";})(QuestRewardCategory||(QuestRewardCategory={}));var QuestRewardType;(function(QuestRewardType){QuestRewardType["ArcadePart"]="ARCADE_PART";QuestRewardType["ArcadePartRandom"]="ARCADE_PART_RANDOM";QuestRewardType["CollectibleItem"]="COLLECTIBLE_ITEM";QuestRewardType["JunkPart"]="JUNK_PART";QuestRewardType["JunkPartRandom"]="JUNK_PART_RANDOM";QuestRewardType["Teras"]="TERAS";})(QuestRewardType||(QuestRewardType={}));var QuestScalarFieldEnum;(function(QuestScalarFieldEnum){QuestScalarFieldEnum["CompletedAt"]="completedAt";QuestScalarFieldEnum["CreatedAt"]="createdAt";QuestScalarFieldEnum["Id"]="id";QuestScalarFieldEnum["QuestChainId"]="questChainId";QuestScalarFieldEnum["QuestMasterId"]="questMasterId";QuestScalarFieldEnum["StartAt"]="startAt";QuestScalarFieldEnum["UpdatedAt"]="updatedAt";})(QuestScalarFieldEnum||(QuestScalarFieldEnum={}));var RewardCategory;(function(RewardCategory){RewardCategory["Accumulator"]="ACCUMULATOR";RewardCategory["Frame"]="FRAME";RewardCategory["Icon"]="ICON";RewardCategory["LowerCabinet"]="LOWER_CABINET";RewardCategory["Rom"]="ROM";RewardCategory["Teras"]="TERAS";RewardCategory["Title"]="TITLE";RewardCategory["UpperCabinet"]="UPPER_CABINET";})(RewardCategory||(RewardCategory={}));var RewardItemType;(function(RewardItemType){RewardItemType["ArcadePart"]="ARCADE_PART";RewardItemType["CollectibleItem"]="COLLECTIBLE_ITEM";RewardItemType["JunkPart"]="JUNK_PART";RewardItemType["Teras"]="TERAS";})(RewardItemType||(RewardItemType={}));var RewardScalarFieldEnum;(function(RewardScalarFieldEnum){RewardScalarFieldEnum["AcceptedAt"]="acceptedAt";RewardScalarFieldEnum["Amount"]="amount";RewardScalarFieldEnum["AvailableUntil"]="availableUntil";RewardScalarFieldEnum["Category"]="category";RewardScalarFieldEnum["CreatedAt"]="createdAt";RewardScalarFieldEnum["Id"]="id";RewardScalarFieldEnum["RewardItemType"]="rewardItemType";RewardScalarFieldEnum["SubCategory"]="subCategory";RewardScalarFieldEnum["Title"]="title";RewardScalarFieldEnum["UpdatedAt"]="updatedAt";RewardScalarFieldEnum["UserId"]="userId";})(RewardScalarFieldEnum||(RewardScalarFieldEnum={}));var SortOrder;(function(SortOrder){SortOrder["Asc"]="asc";SortOrder["Desc"]="desc";})(SortOrder||(SortOrder={}));/** Currency used for start quest chain */var StartQuestChainCurrencyType;(function(StartQuestChainCurrencyType){StartQuestChainCurrencyType["Akv"]="AKV";StartQuestChainCurrencyType["Teras"]="TERAS";StartQuestChainCurrencyType["Ticket"]="TICKET";})(StartQuestChainCurrencyType||(StartQuestChainCurrencyType={}));var TicketTransactionType;(function(TicketTransactionType){TicketTransactionType["EnterTournament"]="ENTER_TOURNAMENT";TicketTransactionType["OpenQuest"]="OPEN_QUEST";TicketTransactionType["Purchase"]="PURCHASE";TicketTransactionType["TournamentBooster"]="TOURNAMENT_BOOSTER";})(TicketTransactionType||(TicketTransactionType={}));var UserScalarFieldEnum;(function(UserScalarFieldEnum){UserScalarFieldEnum["Admin"]="admin";UserScalarFieldEnum["AkirBalance"]="akirBalance";UserScalarFieldEnum["AkvBalance"]="akvBalance";UserScalarFieldEnum["CreatedAt"]="createdAt";UserScalarFieldEnum["Email"]="email";UserScalarFieldEnum["FrameSubCategory"]="frameSubCategory";UserScalarFieldEnum["IconSubCategory"]="iconSubCategory";UserScalarFieldEnum["IconType"]="iconType";UserScalarFieldEnum["Id"]="id";UserScalarFieldEnum["LockedAt"]="lockedAt";UserScalarFieldEnum["Name"]="name";UserScalarFieldEnum["TerasBalance"]="terasBalance";UserScalarFieldEnum["Tickets"]="tickets";UserScalarFieldEnum["TitleSubCategory"]="titleSubCategory";UserScalarFieldEnum["UpdatedAt"]="updatedAt";UserScalarFieldEnum["WalletAddress"]="walletAddress";})(UserScalarFieldEnum||(UserScalarFieldEnum={}));var WithdrawalState;(function(WithdrawalState){WithdrawalState["Confirmed"]="CONFIRMED";WithdrawalState["Error"]="ERROR";WithdrawalState["Pending"]="PENDING";WithdrawalState["Unprocessed"]="UNPROCESSED";})(WithdrawalState||(WithdrawalState={}));var WithdrawalType;(function(WithdrawalType){WithdrawalType["Mint"]="MINT";WithdrawalType["Transfer"]="TRANSFER";})(WithdrawalType||(WithdrawalType={}));var TokenRefreshDocument=(0,lib/* gql */.Ps)(_templateObject||(_templateObject=(0,taggedTemplateLiteral/* default */.Z)(["\n    query TokenRefresh($refreshToken: String) {\n  tokenRefresh(refreshToken: $refreshToken, requestNewAuth: true) {\n    firebaseCustomToken\n  }\n}\n    "])));/**
 * __useTokenRefreshQuery__
 *
 * To run a query within a React component, call `useTokenRefreshQuery` and pass it any options that fit your needs.
 * When your component renders, `useTokenRefreshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTokenRefreshQuery({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */function useTokenRefreshQuery(baseOptions){var options=query_generated_objectSpread(query_generated_objectSpread({},defaultOptions),baseOptions);return Apollo.useQuery(TokenRefreshDocument,options);}function useTokenRefreshLazyQuery(baseOptions){var options=query_generated_objectSpread(query_generated_objectSpread({},defaultOptions),baseOptions);return Apollo.useLazyQuery(TokenRefreshDocument,options);}var RequestWeb3ChallengeDocument=(0,lib/* gql */.Ps)(_templateObject2||(_templateObject2=(0,taggedTemplateLiteral/* default */.Z)(["\n    mutation requestWeb3Challenge($input: RequestWeb3ChallengeInput!) {\n  RequestWeb3Challenge(input: $input) {\n    message\n    sessionToken\n  }\n}\n    "])));/**
 * __useRequestWeb3ChallengeMutation__
 *
 * To run a mutation, you first call `useRequestWeb3ChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestWeb3ChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestWeb3ChallengeMutation, { data, loading, error }] = useRequestWeb3ChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */function useRequestWeb3ChallengeMutation(baseOptions){var options=query_generated_objectSpread(query_generated_objectSpread({},defaultOptions),baseOptions);return useMutation/* useMutation */.D(RequestWeb3ChallengeDocument,options);}
// EXTERNAL MODULE: ./src/services/MetamaskService.ts
var MetamaskService = __webpack_require__(2483);
// EXTERNAL MODULE: ./src/views/states/LoginUser/index.tsx + 1 modules
var LoginUser = __webpack_require__(8655);
// EXTERNAL MODULE: ./src/views/providers/graphql/index.ts + 8 modules
var graphql = __webpack_require__(8628);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/esm/index.esm.js + 2 modules
var index_esm = __webpack_require__(8256);
// EXTERNAL MODULE: ./src/services/FirebaseService.ts + 1 modules
var FirebaseService = __webpack_require__(5732);
// EXTERNAL MODULE: ./src/services/LocalStorageService.ts + 1 modules
var LocalStorageService = __webpack_require__(830);
// EXTERNAL MODULE: ./src/views/states/FirebaseUser/index.tsx
var FirebaseUser = __webpack_require__(3855);
// EXTERNAL MODULE: ./src/services/AuthService.ts
var AuthService = __webpack_require__(746);
;// CONCATENATED MODULE: ./src/views/pages/LoginPage/useProps.ts

















var useProps = function useProps() {
  var router = (0,next_router.useRouter)();
  var firebaseUser = (0,FirebaseUser/* useFirebaseUser */.I)().firebaseUser;

  var _useState = (0,react.useState)(''),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isProcessingEmailLogin = _useState2[0],
      setIsAuthenticationgEmailLogin = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isProcessingMetamaskLogin = _useState3[0],
      setIsProcessingMetamaskLogin = _useState3[1];

  var disabledSubmit = !ValidationService/* ValidationService.isValidEmail */.R.isValidEmail(email) || isProcessingEmailLogin;

  var _useRequestWeb3Challe = useRequestWeb3ChallengeMutation(),
      _useRequestWeb3Challe2 = (0,slicedToArray/* default */.Z)(_useRequestWeb3Challe, 1),
      requestWeb3Challenge = _useRequestWeb3Challe2[0];

  var _useLoginUser = (0,LoginUser/* useLoginUser */.x)(),
      reload = _useLoginUser.reload;

  var gotoTop = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _auth$currentUser, _result$claims;

    var result;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (_auth$currentUser = FirebaseService/* auth.currentUser */.I.currentUser) === null || _auth$currentUser === void 0 ? void 0 : _auth$currentUser.getIdTokenResult();

          case 2:
            result = _context.sent;

            if (result !== null && result !== void 0 && (_result$claims = result.claims) !== null && _result$claims !== void 0 && _result$claims.akiverseId) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            _context.next = 7;
            return reload();

          case 7:
            router.push(PagePathService/* PagePathService.myPage */.v.myPage());

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [router, reload]);
  var onClickEmailLogin = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var _auth$currentUser2, _auth$currentUser3, idTokenResult, akiverseId, locked;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setIsAuthenticationgEmailLogin(true);
            LocalStorageService/* LocalStorageService.removeEmailSignin */.n.removeEmailSignin();
            LocalStorageService/* LocalStorageService.removeEmailLogin */.n.removeEmailLogin();

            if (!(!!FirebaseService/* auth.currentUser */.I.currentUser && FirebaseService/* auth.currentUser.email */.I.currentUser.email === email)) {
              _context2.next = 22;
              break;
            }

            _context2.next = 6;
            return (_auth$currentUser2 = FirebaseService/* auth.currentUser */.I.currentUser) === null || _auth$currentUser2 === void 0 ? void 0 : _auth$currentUser2.getIdToken(true);

          case 6:
            _context2.next = 8;
            return (_auth$currentUser3 = FirebaseService/* auth.currentUser */.I.currentUser) === null || _auth$currentUser3 === void 0 ? void 0 : _auth$currentUser3.getIdTokenResult();

          case 8:
            idTokenResult = _context2.sent;
            akiverseId = !!(idTokenResult !== null && idTokenResult !== void 0 && idTokenResult.claims.akiverseId);

            if (akiverseId) {
              _context2.next = 14;
              break;
            }

            alert('There are no users with this email address.\nPlease register at Sign up.');
            setIsAuthenticationgEmailLogin(false);
            return _context2.abrupt("return");

          case 14:
            locked = !!(idTokenResult !== null && idTokenResult !== void 0 && idTokenResult.claims.locked);

            if (!locked) {
              _context2.next = 19;
              break;
            }

            router.push(PagePathService/* PagePathService.accountLocked */.v.accountLocked());
            setIsAuthenticationgEmailLogin(false);
            return _context2.abrupt("return");

          case 19:
            gotoTop();
            setIsAuthenticationgEmailLogin(false);
            return _context2.abrupt("return");

          case 22:
            _context2.next = 24;
            return AuthService/* AuthService.logOut */.e.logOut();

          case 24:
            (0,index_esm/* sendSignInLinkToEmail */.oo)(FirebaseService/* auth */.I, email, {
              url: "https://world-manager.akiverse.io/login-complete",
              handleCodeInApp: true
            }).then(function () {
              LocalStorageService/* LocalStorageService.saveEmailLogin */.n.saveEmailLogin(email);
              router.push(PagePathService/* PagePathService.mailSendComplete */.v.mailSendComplete());
              setIsAuthenticationgEmailLogin(false);
            })["catch"](function (error) {
              console.log(error);
              alert("Error: ".concat(error.message));
              setIsAuthenticationgEmailLogin(false);
            });

          case 25:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [email, gotoTop, router]);
  var onClickMetamaskLogin = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            setIsProcessingMetamaskLogin(true);
            LocalStorageService/* LocalStorageService.removeEmailSignin */.n.removeEmailSignin();
            LocalStorageService/* LocalStorageService.removeEmailLogin */.n.removeEmailLogin();

            if (MetamaskService/* MetamaskService.isInstalledMetamask */.G.isInstalledMetamask()) {
              _context4.next = 6;
              break;
            }

            setIsProcessingMetamaskLogin(false);
            return _context4.abrupt("return", alert('Please install Metamask in your browser.'));

          case 6:
            _context4.next = 8;
            return AuthService/* AuthService.logOut */.e.logOut();

          case 8:
            MetamaskService/* MetamaskService.getWalletAddress */.G.getWalletAddress().then(function (walletAddress) {
              if (!walletAddress) {
                setIsProcessingMetamaskLogin(false);
                return alert('Metamask account is not connected to Akiverse.');
              }

              requestWeb3Challenge({
                variables: {
                  input: {
                    chain: "0x89",
                    walletAddress: walletAddress
                  }
                }
              }).then(function (res) {
                if (res.errors) {
                  setIsProcessingMetamaskLogin(false);
                  alert('Login Error'); //TODO
                } else {
                  var _res$data$RequestWeb, _res$data;

                  var message = (_res$data$RequestWeb = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.RequestWeb3Challenge.message) !== null && _res$data$RequestWeb !== void 0 ? _res$data$RequestWeb : '';
                  MetamaskService/* MetamaskService.signMessage */.G.signMessage(message).then(function (signature) {
                    graphql/* graphqlClient.login */.S.login({
                      message: message,
                      signature: signature
                    }).then( /*#__PURE__*/function () {
                      var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref4) {
                        var _auth$currentUser4, _auth$currentUser5;

                        var firebaseCustomToken, idTokenResult, locked;
                        return regenerator_default().wrap(function _callee3$(_context3) {
                          while (1) {
                            switch (_context3.prev = _context3.next) {
                              case 0:
                                firebaseCustomToken = _ref4.login.firebaseCustomToken;
                                _context3.next = 3;
                                return (0,index_esm/* signInWithCustomToken */._p)(FirebaseService/* auth */.I, firebaseCustomToken);

                              case 3:
                                _context3.next = 5;
                                return (_auth$currentUser4 = FirebaseService/* auth.currentUser */.I.currentUser) === null || _auth$currentUser4 === void 0 ? void 0 : _auth$currentUser4.getIdToken(true);

                              case 5:
                                _context3.next = 7;
                                return (_auth$currentUser5 = FirebaseService/* auth.currentUser */.I.currentUser) === null || _auth$currentUser5 === void 0 ? void 0 : _auth$currentUser5.getIdTokenResult();

                              case 7:
                                idTokenResult = _context3.sent;
                                locked = !!(idTokenResult !== null && idTokenResult !== void 0 && idTokenResult.claims.locked);

                                if (!locked) {
                                  _context3.next = 13;
                                  break;
                                }

                                router.push(PagePathService/* PagePathService.accountLocked */.v.accountLocked());
                                setIsAuthenticationgEmailLogin(false);
                                return _context3.abrupt("return");

                              case 13:
                                setIsProcessingMetamaskLogin(false);

                              case 14:
                              case "end":
                                return _context3.stop();
                            }
                          }
                        }, _callee3);
                      }));

                      return function (_x) {
                        return _ref5.apply(this, arguments);
                      };
                    }())["catch"](function (error) {
                      var _error$response, _error$response$error, _error$response$error2, _error$response$error3;

                      setIsProcessingMetamaskLogin(false);
                      var errorCode = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$error = _error$response.errors) === null || _error$response$error === void 0 ? void 0 : (_error$response$error2 = _error$response$error[0]) === null || _error$response$error2 === void 0 ? void 0 : (_error$response$error3 = _error$response$error2.extensions) === null || _error$response$error3 === void 0 ? void 0 : _error$response$error3.code;

                      if (errorCode === 'NOT_FOUND') {
                        // ユーザーが存在しない場合
                        alert('This Metamask is not user-linked.');
                      } else {
                        alert('Login Error'); //TODO
                      }
                    });
                  })["catch"](function () {
                    alert('Login Error'); //TODO

                    setIsProcessingMetamaskLogin(false);
                  });
                }
              });
            });

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [requestWeb3Challenge]);
  (0,react.useEffect)(function () {
    if (firebaseUser && AuthService/* AuthService.isLoggedIn */.e.isLoggedIn()) {
      gotoTop();
    }
  }, [firebaseUser, gotoTop]);
  return {
    onUpdateEmail: setEmail,
    onClickEmailLogin: onClickEmailLogin,
    onClickMetamaskLogin: onClickMetamaskLogin,
    disabledSubmit: disabledSubmit,
    visibleEmailLoginIndicator: isProcessingEmailLogin,
    visibleMetamaskLoginIndicator: isProcessingMetamaskLogin,
    GlobalNavigationHeaderProps: (0,GlobalNavigationHeader_useProps/* useProps */.w)()
  };
};
;// CONCATENATED MODULE: ./src/views/pages/LoginPage/index.tsx


function LoginPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LoginPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LoginPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LoginPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Component = function Component() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout, LoginPage_objectSpread({}, useProps()));
};

var LoginPage = function LoginPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AgreementProvider/* AgreementProvider */.J, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {})
  });
};
;// CONCATENATED MODULE: ./src/pages/login/index.tsx



var Page = function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LoginPage, {});
};

/* harmony default export */ var login = (Page);

/***/ }),

/***/ 8954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ValidationService; }
/* harmony export */ });
var ValidationService = {
  isValidEmail: function isValidEmail(email) {
    var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return regex.test(email);
  },
  contains8Characters: function contains8Characters(password) {
    var regex = /^\S{8,99}$/;
    return regex.test(password);
  },
  containsSpecialCharacters: function containsSpecialCharacters(password) {
    var regex = /.*[\^$*.\[\]{}\(\)?\-"!@#%&\/\\,><\':;|_~`]/;
    return regex.test(password);
  },
  containsUpperCaseLetters: function containsUpperCaseLetters(password) {
    var regex = /.*[A-Z]/;
    return regex.test(password);
  },
  containsNumbers: function containsNumbers(password) {
    var regex = /.*[0-9]/;
    return regex.test(password);
  },
  isValidPassword: function isValidPassword(password) {
    return ValidationService.contains8Characters(password) && ValidationService.containsSpecialCharacters(password) && ValidationService.containsUpperCaseLetters(password) && ValidationService.containsNumbers(password);
  }
};

/***/ }),

/***/ 3700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(6994);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7942)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4804,4050,942,9774,2888,179], function() { return __webpack_exec__(3700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);